// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// cellEntryGroup (#360) — which of the three visual groups a scheduled-cell
// entry belongs to in the Optimizer.
//
// Mervin's report: real jobs get lost among repeated "SHARED JAX" / "SHARED MAC"
// entries. The fix (Option C) groups a cell's entries so jobs read first, the
// shared-location entries collapse into one bar, and the attribute rows
// (OFF / BUFFER / custom / compliance hold) stay last:
//
//     jobs  →  ▸ Shared (N)  →  attributes
//
// This pure function is the single decision the render loop uses to bucket each
// entry, extracted so it can be unit-tested against the exact classification the
// UI applies (Optimizer only — the Scheduler tab is unchanged).
//
// Precedence matters: an attribute is classified as "attribute" even if its
// location differs, and compliance holds (attribute + complianceHold) are
// attributes — so they never fall into the shared group.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

/**
 * @param {object} project a scheduleArray entry for this installer+day cell
 * @param {string} locationFilter the currently-viewed location code
 * @returns {"attribute"|"job"|"shared"}
 *   - "attribute": OFF / BUFFER / custom availability / compliance hold
 *     (`attribute === true`) — rendered last, unchanged.
 *   - "job": a real job assigned at the viewed location (`location === locationFilter`).
 *   - "shared": a job assigned to this installer at ANOTHER location — the
 *     "SHARED <loc>" entries that get collapsed.
 */
export function cellEntryGroup(project, locationFilter) {
  if (!project) return "attribute";
  // Attributes (incl. compliance holds) are never jobs and never shared.
  if (project.attribute === true || project.complianceHold === true) {
    return "attribute";
  }
  if (project.location === locationFilter) return "job";
  return "shared";
}
